import type { AdminViewDefinition } from "../components/admin-components.js";
import { interactionAdminViews } from "./admin-overlays.js";
import { primaryAdminViews } from "./admin-pages.js";

export const adminViews: AdminViewDefinition[] = [...primaryAdminViews, ...interactionAdminViews];

export const adminViewRoutes = adminViews.map((view) => ({
  id: view.id,
  title: view.title,
  navId: view.navId,
  hash: `#${view.id}`,
}));

export function getAdminView(viewId: string): AdminViewDefinition {
  return adminViews.find((view) => view.id === viewId) ?? fallbackAdminView();
}

function fallbackAdminView(): AdminViewDefinition {
  return adminViews.find((view) => view.id === "installation-dashboard") ?? adminViews[0]!;
}
